import { useNavigate, useRouteError } from "react-router-dom";
import { ErrorPage } from "./ErrorPage";

export interface RouteErrorBoundaryProps {
  /**
   * 홈으로 이동할 기본 경로 (기본값: "/")
   */
  homePath?: string;
  /**
   * 커스텀 타이틀
   */
  title?: string;
  /**
   * 커스텀 설명 문구
   */
  message?: string;
  /**
   * 오류 화면에 표시할 서비스 이름
   */
  serviceName?: string;
  /**
   * 서비스 로고 이미지 경로
   */
  logoSrc?: string;
  /**
   * 홈 이동 버튼 문구
   */
  homeLabel?: string;
}

export function RouteErrorBoundary({
  homePath = "/",
  title,
  message,
  serviceName,
  logoSrc,
  homeLabel,
}: RouteErrorBoundaryProps) {
  const error = useRouteError();
  const navigate = useNavigate();

  return (
    <ErrorPage
      title={title}
      message={message}
      error={error}
      homePath={homePath}
      serviceName={serviceName}
      logoSrc={logoSrc}
      homeLabel={homeLabel}
      onGoHome={() => navigate(homePath)}
      onGoBack={() => {
        if (window.history.length > 1) {
          navigate(-1);
        } else {
          navigate(homePath);
        }
      }}
    />
  );
}
